import { useId } from "react";
import { motion } from "framer-motion";

export const XLogo = ({ size = 36, animated = true }) => {
  const id = useId().replace(/:/g, "");
  const node = (
    <circle cx="23.5" cy="24" r="2.6" fill="#FF2A38" filter={`url(#xg-${id})`} />
  );
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      data-testid="team-x-logo-svg"
    >
      <defs>
        <filter id={`xg-${id}`} x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur stdDeviation="2.4" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <polygon points="10,6 20,6 38,42 28,42" fill="currentColor" opacity="0.92" />
      <polygon points="36,6 26,6 8,42 18,42" fill="#FF2A38" />
      {animated ? (
        <motion.g
          animate={{ scale: [1, 1.35, 1], opacity: [1, 0.7, 1] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          style={{ transformOrigin: "23.5px 24px" }}
        >
          {node}
        </motion.g>
      ) : (
        node
      )}
    </svg>
  );
};

export default XLogo;
